export default {"src":"/_next/static/media/getasugarLogo.ac51628b.svg","height":182,"width":950};